module.exports = __webpack_public_path__ + "static/img/avatar_6.b430e26.png";


//////////////////
// WEBPACK FOOTER
// ./static/avatars/avatar_6.png
// module id = 1597
// module chunks = 61